import { render, staticRenderFns } from "./AnaliseDocumentacaoDocumento.vue?vue&type=template&id=6f9f9094&scoped=true"
import script from "./AnaliseDocumentacaoDocumento.vue?vue&type=script&lang=js"
export * from "./AnaliseDocumentacaoDocumento.vue?vue&type=script&lang=js"
import style0 from "./AnaliseDocumentacaoDocumento.vue?vue&type=style&index=0&id=6f9f9094&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9f9094",
  null
  
)

export default component.exports